module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list mui-content"
  }, [_c('form', {
    staticClass: "search-form"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.keyWord),
      expression: "keyWord"
    }],
    attrs: {
      "type": "text",
      "placeholder": "搜索"
    },
    domProps: {
      "value": (_vm.keyWord)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.keyWord = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "contact-list-box"
  }, [_c('ul', {
    staticClass: "contact-list"
  }, _vm._l((_vm.list), function(item) {
    return _c('li', {
      staticClass: "contact-item"
    }, [_c('router-link', {
      staticClass: "contact-item-link",
      attrs: {
        "to": {
          name: 'detail',
          params: {
            id: item.id
          }
        }
      }
    }, [_c('div', {
      staticClass: "contact-pic-box"
    }, [_c('img', {
      attrs: {
        "src": require("../assets/img/shuijiao.jpg")
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "contact-msg-box"
    }, [_c('div', {
      staticClass: "contact-row-box"
    }, [_c('span', {
      staticClass: "contact-name"
    }, [_vm._v(_vm._s(item.name))]), _c('span', {
      staticClass: "contact-tag"
    }, [_vm._v(_vm._s(item.tag))])]), _vm._v(" "), _c('div', {
      staticClass: "contact-row-box"
    }, [_c('span', {
      staticClass: "contact-phone"
    }, [_vm._v(_vm._s(item.phone))])])])])], 1)
  }))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.10.3.0@vue-loader/lib/template-compiler.js?id=data-v-80952dc8!./~/.10.3.0@vue-loader/lib/selector.js?type=template&index=0!./src/components/List.vue
// module id = 30
// module chunks = 0